// ============================================================================
// RUSSIAN TRANSLATIONS - CHAPTER 1: БЫТИЕ
// ============================================================================
// Уровни 1-13 (13 уровней, 39 вопросов)

export const chapter1Translations = {
  name: "Бытие",
  description: "В начале… Знание оживляет дух",
  
  spiritualWisdom: {
    principle: "Знание оживляет дух",
    scripture: "Истреблен будет народ Мой за недостаток ведения (Осия 4:6)",
    application: "Каждый изученный стих, каждая открытая истина питает нашу душу и укрепляет нашу веру"
  },
  
  levels: {
    1: {
      name: "Сотворение",
      challenge: "В начале сотворил Бог небо и землю…",
      easy: {
        question: "За сколько дней Бог сотворил мир?",
        options: ["5 дней", "6 дней", "7 дней", "8 дней"],
        hint: "Подумайте о дне отдыха в неделе",
        funFact: "💡 На 7-й день Бог почил от всех дел Своих. Это происхождение субботы, еженедельного дня отдыха!"
      },
      medium: {
        question: "Что Бог создал на четвёртый день?",
        options: ["Животных", "Человека", "Солнце, луну и звёзды", "Растения"],
        hint: "Эти творения освещают землю и отмечают время",
        funFact: "🌟 Светила были созданы для знамений, времён, дней и годов!"
      },
      hard: {
        question: "Что означает, что человек создан «по образу Божьему»?",
        options: [
          "Идентичная физическая внешность",
          "Способность творить и любить",
          "Природное бессмертие",
          "Божественная сила"
        ],
        hint: "Речь о духовных и интеллектуальных качествах",
        funFact: "✨ Образ Божий в нас включает творческие способности, нравственное сознание и способность любить!"
      }
    },
    
    2: {
      name: "Искушение в саду",
      challenge: "Змей был хитрее всех зверей полевых…",
      easy: {
        question: "Какое животное искушало Еву в саду?",
        options: ["Лев", "Змей", "Орёл", "Дракон"],
        hint: "Это животное ползает на животе",
        funFact: "🐍 Змей, возможно, имел ноги изначально, но был проклят ползать на животе!"
      },
      medium: {
        question: "Какой была первая реакция Адама и Евы после вкушения запретного плода?",
        options: [
          "Они помолились Богу",
          "Они устыдились и спрятались",
          "Они съели ещё",
          "Они заснули"
        ],
        hint: "Они осознали своё непослушание",
        funFact: "👀 Открылись глаза у них, и узнали они, что наги!"
      },
      hard: {
        question: "Чему учит нас эта история об искушении?",
        options: [
          "Искушение неизбежно и хорошо",
          "Непослушание Богу приводит к духовной смерти",
          "Знание всегда опасно",
          "Бог создал людей, чтобы они грешили"
        ],
        hint: "Речь о послушании и последствиях",
        funFact: "⚡ Возмездие за грех — смерть, но у Бога есть план восстановления!"
      }
    },
    
    3: {
      name: "Каин и Авель",
      challenge: "Где Авель, брат твой?",
      easy: {
        question: "Какая профессия была у Каина?",
        options: ["Пастух", "Земледелец", "Рыбак", "Охотник"],
        hint: "Он возделывал землю",
        funFact: "🌾 Каин был земледельцем, как его отец Адам!"
      },
      medium: {
        question: "Почему Бог не принял приношение Каина?",
        options: [
          "Жертва была недостаточно большой",
          "Проблема была в его сердце и мотивах",
          "Он пришёл слишком поздно",
          "Бог предпочитал Авеля"
        ],
        hint: "Бог смотрит на сердце, а не на внешнее",
        funFact: "💝 Бог смотрит не на лицо, а на сердце и отношение!"
      },
      hard: {
        question: "Чему учит нас эта история о зависти?",
        options: [
          "Зависть естественна",
          "Зависть, если её не контролировать, ведёт к греху",
          "Бог любит создавать конфликты",
          "Зависть делает сильнее"
        ],
        hint: "Речь о контроле наших негативных эмоций",
        funFact: "🔥 Грех лежит у дверей, но мы должны господствовать над ним!"
      }
    },
    
    4: {
      name: "Потоп Ноя",
      challenge: "Сделай себе ковчег…",
      easy: {
        question: "Сколько пар каждого чистого животного Ной взял в ковчег?",
        options: ["1 пара", "2 пары", "7 пар", "10 пар"],
        hint: "Больше, чем нечистых животных",
        funFact: "🦁 Чистых животных по 7 пар, нечистых по 2, для жертвоприношений и размножения!"
      },
      medium: {
        question: "Сколько дней длился потоп?",
        options: ["30 дней", "40 дней", "100 дней", "150 дней"],
        hint: "Это число в Библии символизирует испытание и очищение",
        funFact: "🌊 Дождь шёл 40 дней, но вода усиливалась 150 дней!"
      },
      hard: {
        question: "Что символизирует радуга?",
        options: [
          "Погодное явление",
          "Знак завета Бога с человечеством",
          "Гнев Божий",
          "Конец потопа"
        ],
        hint: "Это знак вечного обещания Бога",
        funFact: "🌈 Радуга — знак завета Бога никогда больше не истреблять всё живое потопом!"
      }
    },
    
    5: {
      name: "Вавилонская башня",
      challenge: "Построим себе город и башню…",
      easy: {
        question: "Что люди хотели построить?",
        options: ["Дворец", "Башню высотою до небес", "Мост", "Сад"],
        hint: "Они хотели достичь неба",
        funFact: "🏗️ Вавилонская башня, вероятно, была зиккуратом — ступенчатым храмом!"
      },
      medium: {
        question: "Как Бог остановил строительство Вавилонской башни?",
        options: [
          "Он разрушил башню",
          "Он смешал их язык",
          "Он послал землетрясение",
          "Он послал ангелов"
        ],
        hint: "Он сделал так, что они не могли общаться",
        funFact: "🗣️ «Вавилон» означает «смешение», потому что там Бог смешал языки!"
      },
      hard: {
        question: "Чему учит нас эта история о гордости?",
        options: [
          "Амбиции всегда хороши",
          "Гордость и желание быть как Бог ведёт к хаосу",
          "Единство всегда от Бога",
          "Строить высокие башни — грех"
        ],
        hint: "Речь о человеческой гордыне и Божьем суверенитете",
        funFact: "⚡ Гордость предшествует падению, и надменность перед крушением!"
      }
    },
    
    6: {
      name: "Призвание Авраама",
      challenge: "Пойди из земли твоей, от родства твоего и из дома отца твоего…",
      easy: {
        question: "Откуда Бог призвал Авраама уйти?",
        options: ["Египет", "Ханаан", "Ур", "Вавилон"],
        hint: "Это был город в Месопотамии",
        funFact: "🏛️ Ур был процветающим городом с идолопоклонством!"
      },
      medium: {
        question: "Что Бог обещал Аврааму?",
        options: [
          "Богатство",
          "Великий народ, землю и потомство",
          "Долголетие",
          "Трон"
        ],
        hint: "Тройное обещание: потомство, земля и благословение",
        funFact: "⭐ Бог обещал Аврааму потомство, как звёзды на небе!"
      },
      hard: {
        question: "Чему учит нас послушание Авраама о вере?",
        options: [
          "Вера требует видеть все ответы",
          "Вера — это послушание Богу, не зная конечного пункта",
          "Вера — это слабость",
          "Послушание необязательно"
        ],
        hint: "Речь о доверии и следовании за Богом",
        funFact: "🚶 Авраам вышел, не зная, куда идёт, — это истинная вера!"
      }
    },
    
    7: {
      name: "Жертвоприношение Исаака",
      challenge: "Бог усмотрит Себе агнца для всесожжения…",
      easy: {
        question: "Кого Авраам должен был принести в жертву?",
        options: ["Своего слугу", "Своего сына Исаака", "Свою жену", "Овцу"],
        hint: "Его единственный сын, которого он любил",
        funFact: "💝 Исаак был сыном обетования, родившимся, когда Аврааму было 100 лет!"
      },
      medium: {
        question: "Что в итоге было принесено в жертву вместо Исаака?",
        options: [
          "Бык",
          "Агнец",
          "Овен, запутавшийся рогами в чаще",
          "Ничего"
        ],
        hint: "Бог приготовил заменяющее животное",
        funFact: "🐏 Овен, запутавшийся рогами, прекрасно прообразует жертву Христа!"
      },
      hard: {
        question: "Какую духовную истину предвосхищает эта история?",
        options: [
          "Бог радуется человеческим жертвам",
          "Бог предоставит то, что Он требует",
          "Человеческие жертвы угодны Богу",
          "Авраам на самом деле не любил Исаака"
        ],
        hint: "Речь о доверии даже тогда, когда мы не понимаем",
        funFact: "💝 Когда мы доверяем Богу, Он всегда предусматривает выход!"
      }
    },

    8: {
      name: "Иаков и Исав",
      challenge: "Больший будет служить меньшему…",
      easy: {
        question: "За что Исав продал своё первородство?",
        options: ["Золото", "Миску чечевичной похлёбки", "Одежду", "Вино"],
        hint: "Миска, чтобы утолить голод",
        funFact: "🍲 Минута голода стоила Исаву вечного благословения!"
      },
      medium: {
        question: "Как Иаков обманул своего отца Исаака?",
        options: [
          "Изменил голос",
          "Переоделся",
          "Покрыл себя козьими шкурами",
          "Солгал о своём имени"
        ],
        hint: "Чтобы походить на волосатого брата",
        funFact: "🎭 Слепой Исаак узнал запах и прикосновение, но не обман!"
      },
      hard: {
        question: "Что эта история раскрывает о наших выборах?",
        options: [
          "Обман иногда необходим",
          "Мгновенные желания могут стоить нам судьбы",
          "Бог одобряет хитрость",
          "Младший всегда предпочтителен"
        ],
        hint: "Речь о последствиях наших импульсивных решений",
        funFact: "⚖️ Наши импульсивные выборы могут иметь вечные последствия!"
      }
    },

    9: {
      name: "Сон Иакова",
      challenge: "Вот, лестница стоит на земле, а верх её касается неба…",
      easy: {
        question: "Что увидел Иаков во сне?",
        options: [
          "Гигантское дерево",
          "Лестницу в небо с ангелами",
          "Храм",
          "Звёзды"
        ],
        hint: "Средство связи между небом и землёй",
        funFact: "👼 Лестница Иакова символизирует связь между Небом и Землёй!"
      },
      medium: {
        question: "Что сделал Иаков с камнем, который служил ему изголовьем?",
        options: [
          "Разбил его",
          "Закопал его",
          "Поставил его и возлил на него елей",
          "Взял его с собой"
        ],
        hint: "Сделал из него священный памятник",
        funFact: "🪨 Этот камень становится 'Вефилем' — домом Божьим!"
      },
      hard: {
        question: "Как это видение соединяет небо и землю в нашей жизни?",
        options: [
          "Только через сны",
          "Через молитву, которая устанавливает мост к божественному",
          "Через ангелов-хранителей",
          "Через святые места"
        ],
        hint: "Речь о нашем общении с Богом",
        funFact: "🌉 Молитва — это наша личная лестница в Небо!"
      }
    },

    10: {
      name: "Иосиф, проданный братьями",
      challenge: "Вот, идёт сновидец…",
      easy: {
        question: "Сколько братьев было у Иосифа?",
        options: ["7 братьев", "10 братьев", "11 братьев", "12 братьев"],
        hint: "На одного меньше числа колен Израилевых",
        funFact: "👨‍👨‍👦‍👦 12 сыновей Иакова станут 12 коленами Израиля!"
      },
      medium: {
        question: "За сколько сребреников был продан Иосиф?",
        options: [
          "10 сребреников",
          "20 сребреников",
          "30 сребреников",
          "50 сребреников"
        ],
        hint: "Цена раба",
        funFact: "💰 20 сребреников — цена раба в то время!"
      },
      hard: {
        question: "Как зависть превращается в инструмент Божьего плана?",
        options: [
          "Бог одобряет зависть",
          "Совершённое зло преобразуется Богом в добро",
          "Зависть необходима",
          "Братья были правы"
        ],
        hint: "Речь о Божьем провидении, превращающем зло в добро",
        funFact: "🎨 Бог превращает даже наши худшие поступки в шедевр благодати!"
      }
    },

    11: {
      name: "Иосиф в темнице",
      challenge: "Господь был с Иосифом и простёр к нему милость…",
      easy: {
        question: "Какой особый дар был у Иосифа?",
        options: [
          "Пророчествовать",
          "Истолковывать сны",
          "Исцелять больных",
          "Говорить с животными"
        ],
        hint: "Способность, связанная со снами",
        funFact: "💭 Сны считались божественными посланиями в древнем мире!"
      },
      medium: {
        question: "Какие слуги фараона были в темнице с Иосифом?",
        options: [
          "Визирь и писец",
          "Виночерпий и хлебодар",
          "Врач и стража",
          "Повар и садовник"
        ],
        hint: "Тот, кто подавал вино, и тот, кто подавал хлеб",
        funFact: "🍷 Виночерпий пробовал вино царя, чтобы предотвратить отравление!"
      },
      hard: {
        question: "Чему учит нас Иосиф о верности в невзгодах?",
        options: [
          "Несправедливость приемлема",
          "Верность Богу превосходит обстоятельства",
          "Темница меняет людей",
          "Нужно мстить"
        ],
        hint: "Речь о сохранении верности даже в испытаниях",
        funFact: "⭐ Даже в темнице Иосиф оставался праведным, и Бог возвысил его!"
      }
    },

    12: {
      name: "Сны фараона",
      challenge: "Семь коров тучных… семь коров тощих…",
      easy: {
        question: "Сколько тощих коров пожрали тучных коров?",
        options: ["5", "6", "7", "8"],
        hint: "Совершенное число",
        funFact: "🐄 Число 7 символизирует совершенство и полноту в Библии!"
      },
      medium: {
        question: "Что означали 7 лет во сне?",
        options: [
          "7 лет войны, затем мир",
          "7 лет изобилия, затем 7 лет голода",
          "7 лет болезни, затем здоровье",
          "7 лет дождя, затем засуха"
        ],
        hint: "Цикл изобилия и недостатка",
        funFact: "🌾 Иосиф спас Египет и свою семью благодаря этому истолкованию!"
      },
      hard: {
        question: "Как Божья мудрость преобразует кризисы?",
        options: [
          "Избегая всех кризисов",
          "Давая предвидение для подготовки",
          "Наказывая нечестивых",
          "Обогащая верующих"
        ],
        hint: "Речь о подготовке и предвидении",
        funFact: "💡 Божья мудрость превращает кризисы в возможности спасения!"
      }
    },

    13: {
      name: "Примирение братьев",
      challenge: "Я Иосиф, брат ваш, которого вы продали…",
      easy: {
        question: "Что положил Иосиф в мешок Вениамина?",
        options: [
          "Золото",
          "Своё кольцо",
          "Свою серебряную чашу",
          "Письмо"
        ],
        hint: "Драгоценная личная вещь",
        funFact: "🏆 Чаша также использовалась для 'гадания' по воде!"
      },
      medium: {
        question: "Какую знаменитую фразу сказал Иосиф о превращении зла в добро?",
        options: [
          "Я прощаю вас",
          "Вы умышляли против меня зло, но Бог обратил это в добро",
          "Забудем прошлое",
          "Мне отмщение, Я воздам"
        ],
        hint: "Фраза о Божьем провидении",
        funFact: "✨ Эта фраза резюмирует всё Божье провидение в нашей жизни!"
      },
      hard: {
        question: "Как прощение разрывает циклы мести?",
        options: [
          "Забывая зло",
          "Освобождая обидчика и обиженного для нового начала",
          "Сначала наказав",
          "Сохраняя дистанцию"
        ],
        hint: "Речь о взаимном освобождении",
        funFact: "🕊️ Прощение Иосифа предвосхищает вселенское Божье прощение!"
      }
    }
  }
};

export default chapter1Translations;
